module.exports = "<p>\n  detail works!\n</p>\n"